import { SettingsScreen, SettingsStructure } from 'structure/settings';
import { componentWithVariants, demoFile, variant } from 'system/demo';

demoFile('structure/settings');

componentWithVariants('SettingsScreen', SettingsScreen, {}, [
    variant(null, {
        state: { roles: ['Owner'] },
        config: SettingsStructure.receivesConfigDefaults,
    }),
    variant('Not an admin', {}),
]);
